export const AboutUsLine = ({ color, rotate, width }) => {
  return (
    <svg
      width={width ? width : "116"}
      height="6"
      viewBox="0 0 116 6"
      fill="none"
      transform={`rotate(${rotate})`}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.333333 3C0.333333 4.47276 1.52724 5.66667 3 5.66667C4.47276 5.66667 5.66667 4.47276 5.66667 3C5.66667 1.52724 4.47276 0.333333 3 0.333333C1.52724 0.333333 0.333333 1.52724 0.333333 3ZM3 3.5H116V2.5H3V3.5Z"
        fill={color ? color : "#986633"}
      />
    </svg>
  );
};

export const WhatasappIcon = () => {
  return (
    <svg
      width="45"
      height="45"
      viewBox="0 0 45 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="45" height="45" rx="22.5" fill="#986633" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.4419 22.2558C14.4419 17.6706 18.159 13.9535 22.7442 13.9535C27.3294 13.9535 31.0465 17.6706 31.0465 22.2558C31.0465 26.841 27.3294 30.5581 22.7442 30.5581C21.1109 30.5581 19.5905 30.0875 18.3078 29.2748C18.0691 29.1236 17.7765 29.0832 17.5058 29.1639L14.6936 30.0033L15.7524 27.5256C15.8775 27.2328 15.8521 26.8974 15.6842 26.6268C14.8967 25.358 14.4419 23.8615 14.4419 22.2558ZM22.7442 12C17.0801 12 12.4884 16.5917 12.4884 22.2558C12.4884 24.0512 12.9505 25.7411 13.7627 27.2105L12.0786 31.151C11.9297 31.4994 11.9957 31.9024 12.2479 32.1851C12.5001 32.4679 12.8931 32.5792 13.2561 32.4708L17.6509 31.1593C19.1522 32.0198 20.892 32.5116 22.7442 32.5116C28.4083 32.5116 33 27.92 33 22.2558C33 16.5917 28.4083 12 22.7442 12ZM24.9834 24.3875L23.6997 25.2916C23.0985 24.9492 22.4339 24.4712 21.7671 23.8044C21.0741 23.1113 20.5602 22.3958 20.1813 21.7394L20.9971 21.047C21.3471 20.7499 21.443 20.2489 21.2273 19.8435L20.1879 17.89C20.0479 17.627 19.7956 17.4422 19.5025 17.3882C19.2095 17.3343 18.9078 17.417 18.6833 17.6129L18.3752 17.8819C17.6341 18.5287 17.1958 19.5915 17.5591 20.6677C17.9357 21.7834 18.7394 23.5393 20.3859 25.1858C22.1573 26.9572 23.9566 27.6548 25.0089 27.9257C25.8567 28.1439 26.659 27.8514 27.2243 27.3908L27.8021 26.92C28.0492 26.7187 28.1825 26.4093 28.1593 26.0914C28.1359 25.7735 27.9589 25.4869 27.685 25.3237L26.0458 24.3469C25.7147 24.1497 25.2986 24.1655 24.9834 24.3875Z"
        fill="white"
      />
    </svg>
  );
};
export const InstagramLogo = () => {
  return (
    <svg
      width="45"
      height="45"
      viewBox="0 0 45 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="45" height="45" rx="22.5" fill="#986633" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 16.2C12 13.8804 13.8804 12 16.2 12H28.8C31.1196 12 33 13.8804 33 16.2V28.8C33 31.1196 31.1196 33 28.8 33H16.2C13.8804 33 12 31.1196 12 28.8V16.2ZM16.2 14.1C15.0402 14.1 14.1 15.0402 14.1 16.2V28.8C14.1 29.9598 15.0402 30.9 16.2 30.9H28.8C29.9598 30.9 30.9 29.9598 30.9 28.8V16.2C30.9 15.0402 29.9598 14.1 28.8 14.1H16.2ZM22.5 19.35C20.7603 19.35 19.35 20.7603 19.35 22.5C19.35 24.2397 20.7603 25.65 22.5 25.65C24.2397 25.65 25.65 24.2397 25.65 22.5C25.65 20.7603 24.2397 19.35 22.5 19.35ZM17.25 22.5C17.25 19.6005 19.6005 17.25 22.5 17.25C25.3995 17.25 27.75 19.6005 27.75 22.5C27.75 25.3995 25.3995 27.75 22.5 27.75C19.6005 27.75 17.25 25.3995 17.25 22.5ZM28.275 18.3C29.1448 18.3 29.85 17.5949 29.85 16.725C29.85 15.8551 29.1448 15.15 28.275 15.15C27.4052 15.15 26.7 15.8551 26.7 16.725C26.7 17.5949 27.4052 18.3 28.275 18.3Z"
        fill="white"
      />
    </svg>
  );
};

export const GmailLogo = () => {
  return (
    <svg
      width="45"
      height="45"
      viewBox="0 0 45 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="45" height="45" rx="22.5" fill="#986633" />
      <path
        d="M13.1667 15.9834L22.5 22.8667L31.8334 15.9834"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M30.6667 14H14.3333C13.0447 14 12 15.0447 12 16.3333V28C12 29.2887 13.0447 30.3333 14.3333 30.3333H30.6667C31.9553 30.3333 33 29.2887 33 28V16.3333C33 15.0447 31.9553 14 30.6667 14Z"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const ZomatoIcon = (props) => {
  const { height, width } = props;
  return (
    <svg
      width={width ? width : "45"}
      height={height ? height : "45"}
      viewBox="0 0 45 45"
      fill="none"
      {...props}
    >
      <g clip-path="url(#clip0_2003_112)">
        <path
          d="M1.58513 0.807549H43.4148C44.0142 0.807549 44.5 1.2934 44.5 1.89268V43.7224C44.5 44.3217 44.0142 44.8075 43.4148 44.8075H1.58513C0.985822 44.8075 0.5 44.3217 0.5 43.7224V1.89268C0.5 1.2934 0.985822 0.807549 1.58513 0.807549Z"
          fill="#E3263F"
        />
        <path
          d="M35.3146 24.9383L35.0808 26.3858C34.7184 26.5818 34.0404 26.8639 33.257 26.8639C31.9244 26.8639 31.6554 26.1526 31.8659 24.644L32.2049 22.2155H31.5493L31.7347 20.6436L32.4504 20.609L32.7193 19.4683L34.7417 18.7079L34.4845 20.609H35.8758C35.8289 20.8052 35.6653 21.8844 35.6186 22.2155H34.2625L33.9584 24.46C33.8766 25.0365 33.9235 25.245 34.3209 25.245C34.6131 25.245 35.0458 25.0733 35.3146 24.9383ZM24.8126 22.4732C24.9647 21.4305 24.8827 20.4863 23.7255 20.4863C22.8839 20.4863 21.9719 21.1976 21.329 22.3873C21.4692 21.406 21.3875 20.4863 20.2418 20.4863C19.3767 20.4863 18.4414 21.2344 17.7985 22.4732C17.9621 21.6636 17.927 20.7438 17.8802 20.5474C17.214 20.6581 16.6295 20.7192 15.8111 20.7438C15.8345 21.308 15.7993 22.0439 15.6942 22.7429L15.4253 24.5827C15.3201 25.3063 15.2033 26.1406 15.0863 26.6678H17.2608C17.2724 26.3489 17.3542 25.846 17.4127 25.4043L17.5997 24.1413C17.7517 23.3194 18.4064 22.3506 18.9091 22.3506C19.2014 22.3506 19.1896 22.6326 19.1079 23.1601L18.8974 24.5827C18.7922 25.3063 18.6752 26.1406 18.5583 26.6678H20.7561C20.7678 26.3489 20.838 25.846 20.8965 25.4043L21.0835 24.1413C21.2355 23.3194 21.8902 22.3506 22.3927 22.3506C22.6851 22.3506 22.6734 22.6202 22.6265 22.9883L22.1018 26.6678H24.1075L24.8126 22.4732ZM41.7912 23.13C41.7912 25.1927 40.3342 26.9075 38.4036 26.9075C36.6744 26.9075 35.7862 25.727 35.7862 24.1862C35.7862 22.136 37.2548 20.4211 39.1737 20.4211C40.9264 20.4211 41.7912 21.6016 41.7912 23.13ZM37.8904 24.1456C37.8904 24.8939 38.1358 25.2741 38.5568 25.2741C39.118 25.2741 39.5622 24.3666 39.5622 23.2626C39.5622 22.5022 39.3167 22.1343 38.9074 22.1343C38.3463 22.1343 37.8904 23.0296 37.8904 24.1456ZM14.9811 23.1727C14.9811 25.2085 13.5431 26.9011 11.6376 26.9011C9.93078 26.9011 9.05394 25.736 9.05394 24.2152C9.05394 22.1916 10.5036 20.499 12.3975 20.499C14.1277 20.499 14.9811 21.6642 14.9811 23.1727ZM11.1583 24.1456C11.1583 24.8939 11.4038 25.2741 11.8245 25.2741C12.3858 25.2741 12.83 24.3666 12.83 23.2626C12.83 22.5022 12.5845 22.1343 12.1753 22.1343C11.6142 22.1343 11.1583 23.0296 11.1583 24.1456ZM9.0891 20.6457L9.05394 21.7618L6.14312 24.9262C7.35889 24.9262 8.13043 24.9138 8.57474 24.8894C8.44608 25.4904 8.34088 25.981 8.23572 26.7166C7.65118 26.6678 6.73923 26.6555 5.82747 26.6555C4.81042 26.6555 3.92191 26.6678 3.20874 26.7166L3.2322 25.5885L6.14312 22.4363C4.86879 22.4363 4.40126 22.4486 3.8751 22.4609C3.99197 21.8968 4.07389 21.2712 4.15575 20.6457C5.07929 20.6825 5.44163 20.6947 6.64582 20.6947C7.75638 20.6947 8.38761 20.6825 9.0891 20.6457Z"
          fill="white"
        />
        <path
          d="M27.0173 26.748C25.9788 26.8757 25.2946 26.4635 25.0893 25.5254C24.9602 24.9352 25.139 24.2635 25.4521 23.862C25.8709 23.3376 26.5542 23.0006 27.3872 22.8985C28.0579 22.8161 28.6228 22.8568 29.1512 22.9569L29.1731 22.8661C29.1881 22.7214 29.2032 22.5765 29.182 22.403C29.1274 21.9589 28.7765 21.6939 27.9111 21.8001C27.327 21.8719 26.771 22.0831 26.3392 22.3233L25.9199 21.0547C26.5045 20.7188 27.2419 20.4634 28.0856 20.3598C29.6974 20.1619 30.8295 20.676 30.9746 21.8573C31.0131 22.1716 31.0178 22.5049 30.978 22.8066C30.7708 24.2676 30.6382 25.3666 30.5802 26.1038C30.5712 26.2175 30.572 26.4134 30.5823 26.6917L28.5824 26.6899C28.6248 26.5744 28.663 26.4187 28.697 26.223C28.7192 26.0942 28.7353 25.9313 28.7457 25.7347C28.3226 26.3146 27.742 26.6592 27.0173 26.748ZM27.6444 25.6266C28.38 25.5362 28.8866 24.8264 29.0084 24.1185L29.0288 23.9288C28.7127 23.8577 28.2559 23.8038 27.8124 23.8582C27.3905 23.9102 27.0388 24.0853 26.8503 24.3395C26.708 24.5218 26.6359 24.7398 26.6677 24.9997C26.7158 25.3899 27.1469 25.6876 27.6444 25.6266Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_2003_112">
          <rect
            x="0.5"
            y="0.807678"
            width="44"
            height="44"
            rx="4.4"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const SwiggyIcon = (props) => {
  const { height, width } = props;
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="4" fill="#FC8019" />
      <g clip-path="url(#clip0_2081_7)">
        <path
          d="M16.028 25C16.0168 24.9887 16.0056 24.9773 15.9944 24.9659C15.7815 24.693 14.4594 23.0101 13.1036 20.8611C12.7003 20.1788 12.4314 19.633 12.4874 19.4966C12.6218 19.1327 14.9748 18.9394 15.6919 19.2691C15.916 19.3715 15.9047 19.4966 15.9047 19.5762C15.9047 19.9059 15.8935 20.7928 15.8935 20.7928C15.8935 20.9748 16.0392 21.1226 16.2185 21.1226C16.3977 21.1226 16.5434 20.9748 16.5434 20.7928V18.5869C16.5434 18.3936 16.3417 18.3481 16.2969 18.3367C15.916 18.3367 15.154 18.3367 14.3249 18.3367C12.5098 18.3367 12.0952 18.4163 11.7927 18.2117C11.1204 17.7682 10.0336 14.7777 9.99999 13.0948C9.96637 10.7183 11.3557 8.66018 13.3053 7.64818C14.1232 7.22746 15.042 7.00004 16.0168 7.00004C19.1204 6.9773 21.6639 9.34243 22 12.3898C22 12.3898 22 12.3898 22 12.4012C22.0672 13.1403 18.0672 13.2995 17.2717 13.0834C17.1484 13.0493 17.1148 12.9242 17.1148 12.8674C17.1148 12.3102 17.1148 10.7297 17.1148 10.7297C17.1148 10.5477 16.9692 10.3999 16.7899 10.3999C16.6106 10.3999 16.465 10.5477 16.465 10.7297L16.4762 13.6292C16.4762 13.8112 16.633 13.8566 16.6779 13.868C17.126 13.868 18.1793 13.868 19.1653 13.868C20.4874 13.868 21.0476 14.0272 21.4174 14.3115C21.6639 14.5048 21.7535 14.8686 21.6751 15.3348C20.9132 19.5648 16.2073 24.784 16.028 25Z"
          fill="#FCF3E8"
        />
      </g>
      <defs>
        <clipPath id="clip0_2081_7">
          <rect
            width="12"
            height="18"
            fill="white"
            transform="translate(10 7)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const SwiggySmallIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <rect width="24" height="24" rx="2.4" fill="#FC8019" />
      <g clip-path="url(#clip0_2005_51)">
        <path
          d="M12.0279 21C12.0167 20.9886 12.0055 20.9773 11.9943 20.9659C11.7814 20.693 10.4593 19.0101 9.10357 16.861C8.70021 16.1788 8.4313 15.633 8.48732 15.4965C8.62177 15.1327 10.9747 14.9394 11.6918 15.2691C11.9159 15.3714 11.9047 15.4965 11.9047 15.5761C11.9047 15.9059 11.8935 16.7928 11.8935 16.7928C11.8935 16.9747 12.0391 17.1226 12.2184 17.1226C12.3977 17.1226 12.5433 16.9747 12.5433 16.7928V14.5869C12.5433 14.3936 12.3417 14.3481 12.2968 14.3367C11.9159 14.3367 11.154 14.3367 10.3249 14.3367C8.50973 14.3367 8.09516 14.4163 7.79264 14.2116C7.12037 13.7682 6.03354 10.7776 5.99993 9.09476C5.96631 6.71826 7.35567 4.66014 9.30525 3.64814C10.1232 3.22742 11.0419 3 12.0167 3C15.1204 2.97726 17.6638 5.34239 17.9999 8.38977C17.9999 8.38977 17.9999 8.38977 17.9999 8.40114C18.0672 9.14024 14.0672 9.29944 13.2716 9.08339C13.1484 9.04928 13.1148 8.9242 13.1148 8.86734C13.1148 8.31017 13.1148 6.72963 13.1148 6.72963C13.1148 6.5477 12.9691 6.39988 12.7898 6.39988C12.6106 6.39988 12.4649 6.5477 12.4649 6.72963L12.4761 9.62919C12.4761 9.81112 12.633 9.85661 12.6778 9.86798C13.126 9.86798 14.1792 9.86798 15.1652 9.86798C16.4873 9.86798 17.0475 10.0272 17.4173 10.3114C17.6638 10.5047 17.7534 10.8686 17.675 11.3348C16.9131 15.5648 12.2072 20.784 12.0279 21Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_2005_51">
          <rect
            width="12"
            height="18"
            fill="white"
            transform="translate(5.99994 3)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const LocationIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        d="M10 17.5C12.9167 14.5 15.8334 11.8137 15.8334 8.5C15.8334 5.18629 13.2217 2.5 10 2.5C6.77836 2.5 4.16669 5.18629 4.16669 8.5C4.16669 11.8137 7.08335 14.5 10 17.5Z"
        stroke="#FCF3E8"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10 10.8333C11.3807 10.8333 12.5 9.714 12.5 8.33325C12.5 6.95254 11.3807 5.83325 10 5.83325C8.61925 5.83325 7.5 6.95254 7.5 8.33325C7.5 9.714 8.61925 10.8333 10 10.8333Z"
        stroke="#FCF3E8"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const StarIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M7.5216 0.345604C7.67128 -0.115051 8.32298 -0.11505 8.47266 0.345605L10.0178 5.10093C10.0847 5.30694 10.2767 5.44642 10.4933 5.44642H15.4933C15.9777 5.44642 16.1791 6.06623 15.7872 6.35093L11.7421 9.28988C11.5669 9.4172 11.4935 9.64288 11.5605 9.84889L13.1056 14.6042C13.2552 15.0649 12.728 15.4479 12.3361 15.1632L8.29102 12.2243C8.11578 12.097 7.87848 12.097 7.70324 12.2243L3.65812 15.1632C3.26626 15.4479 2.73902 15.0649 2.8887 14.6042L4.4338 9.84889C4.50073 9.64288 4.4274 9.4172 4.25216 9.28988L0.207042 6.35093C-0.184815 6.06623 0.0165745 5.44642 0.500936 5.44642H5.50098C5.71759 5.44642 5.90957 5.30694 5.97651 5.10093L7.5216 0.345604Z"
        fill="url(#paint0_linear_2042_523)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2042_523"
          x1="7.99713"
          y1="8.38208"
          x2="7.99713"
          y2="8.38208"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#E6B800" />
          <stop offset="1" stop-color="#E6B800" />
        </linearGradient>
      </defs>
    </svg>
  );
};
